import React, { useMemo } from "react";

import { Order } from "../../../../../../../services";
import { ColumnId } from "../../columns";
import { CellContentRoot } from "..";

import cellProcessing from "./cellProcessing";

const ExecutorCallStatusCellContent: React.FC<
	ExecutorCallStatusCellContent.Props
> = ({ item }) => {
	const { content, backgroundColor } = useMemo(() => {
		const isCellsReady = !!item?.cellsForTableSettings?.isCellsReady;

		const preparedCell = item?.cellsForTable?.[ColumnId.ExecutorCallStatus];

		const resolvedCell = isCellsReady && preparedCell;

		return resolvedCell ?? cellProcessing(item);
	}, [item]);

	return (
		<CellContentRoot
			alignItems="center"
			backgroundColor={backgroundColor}
			h="100%"
			w="100%"
		>
			{content}
		</CellContentRoot>
	);
};

declare namespace ExecutorCallStatusCellContent {
	interface Props {
		item: Order.Model;
	}
}

export default ExecutorCallStatusCellContent;
